module.exports = __webpack_public_path__ + "static/csgo-344fdf377f91777c2a40af5d6f85fda0.svg";